import {
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK,
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK,
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK,
    FETCH_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK,
    FETCH_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK,
    UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK,
    FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK,
    DELETE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK,
    RESET_PROCESS_ASSIGN_STYLE_MASTER_INFO_DK,
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_FORM_DK,
    UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FORM_DK,
    DELETE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK,
    FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK,
    UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK,
    FETCH_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK,
    DELETE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK,
    UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK,
    FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK
} from './processAssignStyleMaster.actionsType';

export const PROCESS_ASSIGN_STYLE_MASTER_DK = 'processAssignStyleMasterDK';

let initialState = {
    loading: false,
    processAssignStyleMasterList: [],
    processAssignStyleMasterForm: {},
    selectedState: {},
    errorMessage: ''
};

export let processAssignStyleMasterDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK:
        case FETCH_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK:
        case UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK:
        case FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK:
        case DELETE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterList: updatePayload
            };
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: {},
                assignProcessStatus: updatePayload
            };
        case UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: {}
            };
        case FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: updatePayload
            };
        case DELETE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: {}
            };
        case RESET_PROCESS_ASSIGN_STYLE_MASTER_INFO_DK:
            return {
                ...state,
                processAssignStyleMasterForm: {}
            };
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_FORM_DK:
        case UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: {
                    ...state.processAssignStyleMasterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK:
        case UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK:
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK:
        case FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK:
        case DELETE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
